// 广告获取
import request from "@/tool/request"
import API from "@/tool/api"

export default {
    state: {
        // 轮播广告
        banners: [],

        other_page: "", // 富文本页面内容
    },
    mutations: {
        // 轮播广告写入
        writeBanner(state, arg){
            state.banners = arg;
        },

        // 清空轮播广告
        clearBanner(state){
            state.banners = [];
        },

        setOtherPage(state, arg){ // 写入富文本内容
            state.other_page = arg;
        }
    },
    actions: {
        getMainBanner(context){ // 获取首页轮播图
            // 清空数据
            context.commit("clearBanner");
            // 发起请求
            let url = API.banner.main;
            request.get(url).then((res) => {
                if(res.data.code == 1){
					//数据存储
                    context.commit("writeBanner", res.data.banners);
                };
            }).catch(() => {});
        },
        // 影像服务轮播广告
        getPhotographBanner(context){
            // 清空数据
            context.commit("clearBanner");
            // 发起请求
            let url = API.banner.photograph;
            request.get(url).then((res) => {
                if(res.data.code == 1){
                    context.commit("writeBanner", res.data.banners);
                };
            }).catch(() => {});
        },
        
        // 摄影师轮播广告
        getLensmanBanner(context){
            // 清空数据
            context.commit("clearBanner");
            // 发起请求
            let url = API.banner.lensman;
            request.get(url).then((res) => {
                if(res.data.code == 1){
                    context.commit("writeBanner", res.data.banners);
                };
            }).catch(() => {});
        },
        
        // 化妆师轮播广告
        getDresserBanner(context){
            // 清空数据
            context.commit("clearBanner");
            // 发起请求
            let url = API.banner.dresser;
            request.get(url).then((res) => {
                if(res.data.code == 1){
                    context.commit("writeBanner", res.data.banners);
                };
            }).catch(() => {});
        },
        
        // 场地轮播广告
        getFieldBanner(context){
            // 清空数据
            context.commit("clearBanner");
            // 发起请求
            let url = API.banner.field;
            request.get(url).then((res) => {
                if(res.data.code == 1){
                    context.commit("writeBanner", res.data.banners);
                };
            }).catch(() => {});
        },
        // 场地详情轮播广告
        getFieldDetailBanner(context){
            // 清空数据
            context.commit("clearBanner");
            // 发起请求
            let url = API.banner.fieldDetail;
            request.get(url).then((res) => {
                if(res.data.code == 1){
                    context.commit("writeBanner", res.data.banners);
                };
            }).catch(() => {});
        },
        
        // 服饰租赁轮播广告
        getClothesBanner(context){
            // 清空数据
            context.commit("clearBanner");
            // 发起请求
            let url = API.banner.lease;
            request.get(url).then((res) => {
                if(res.data.code == 1){
                    context.commit("writeBanner", res.data.banners);
                };
            }).catch(() => {});
        },
        
        // 影像课堂轮播广告
        getVideoBanner(context){
            // 清空数据
            context.commit("clearBanner");
            // 发起请求
            let url = API.banner.video;
            request.get(url).then((res) => {
                if(res.data.code == 1){
                    context.commit("writeBanner", res.data.banners);
                };
            }).catch(() => {});
        },

        getOtherPage({ commit }, arg){ // 获取富文本数据
            let url = API.banner.article;
            request.get(url, { params: { id: arg } }).then((res) => {
                if(res.data.code == 200){
                    commit("setOtherPage",res.data.result)
                }
            }).catch(() => {})
        },
    },
}
